import { IDropDownInitialState } from "../../types/dropdownInterface";
import { BankDropdown, BankDropdownActionType } from "../actionTypes/master/bankDropdownActionTypes";
import { BranchDropdown, BranchDropdownActionType } from "../actionTypes/master/branchDropdownActionTypes";
import { DepartmentDropdown, DepartmentDropdownActionType } from "../actionTypes/master/departmentDropdownActionTypes";
import { UserDropdown, UserDropdownActionType } from "../actionTypes/userDropdownActionTypes";
import { VehicleDropdown, VehicleDropdownActionType } from "../actionTypes/master/vehicleTypeDropdownActionTypes";
import { PermissionActionTypes, PermissionActions } from "../actionTypes/permissions/permissionTypes";
import { CompanyDropdown, CompanyDropdownActionType } from "../actionTypes/master/companyDropdownActionTypes";
import { PackageActionTypes, PackageActions } from "../actionTypes/master/packageTypes";
import { SectionDropdown, SectionDropdownActionType } from "../actionTypes/permissions/sectionDropdownActionTypes";
import { StateDropdown, StateDropdownActionType } from "../actionTypes/master/StateDropdownActionType";
import { AreaCodeDropdown, AreaCodeDropdownActionType } from "../actionTypes/master/AreaCodeDropdownActionType";

const initialState: IDropDownInitialState = {
  userDropdown: {
    isLoading: false,
    data: [],
  },
  branchDropdown: {
    isLoading: false,
    data: [],
  },
  bankDropdown: {
    isLoading: false,
    data: [],
  },
  departmentDropdown: {
    isLoading: false,
    data: [],
  },
  sectionDropdown: {
    isLoading: false,
    data: [],
    id: 0,
  },
  vehicleDropdown: {
    isLoading: false,
    data: [],
  },
  permissionDropdown: {
    isLoading: false,
    data: [],
  },
  companyDropdown: {
    isLoading: false,
    data: [],
  },
  packageTypeNameAsValueDropdown: {
    isLoading: false,
    data: [],
  },
  stateDropdown: { isLoading: false, data: [] },
  areaCodeDropdown: { isLoading: false, data: [] },
};

export default function dropdownReducer(
  state = initialState,
  action:
    | UserDropdownActionType
    | BranchDropdownActionType
    | DepartmentDropdownActionType
    | BankDropdownActionType
    | VehicleDropdownActionType
    | PermissionActionTypes
    | CompanyDropdownActionType
    | PackageActionTypes
    | SectionDropdownActionType
    | StateDropdownActionType
    | AreaCodeDropdownActionType
) {
  switch (action.type) {
    case UserDropdown.SET_USER_DROPDOWN_LOADING:
      return {
        ...state,
        userDropdown: {
          ...state.userDropdown,
          isLoading: action.payload,
        },
      };

    case UserDropdown.SET_USER_DROPDOWN_LIST:
      return {
        ...state,
        userDropdown: {
          ...state.userDropdown,
          data: action.payload,
        },
      };

    case BranchDropdown.SET_BRANCH_DROPDOWN_LOADING:
      return {
        ...state,
        branchDropdown: {
          ...state.branchDropdown,
          isLoading: action.payload,
        },
      };

    case BranchDropdown.SET_BRANCH_DROPDOWN_LIST:
      return {
        ...state,
        branchDropdown: {
          ...state.branchDropdown,
          data: action.payload,
        },
      };

    case BankDropdown.SET_BANK_DROPDOWN_LOADING:
      return {
        ...state,
        bankDropdown: {
          ...state.bankDropdown,
          isLoading: action.payload,
        },
      };

    case BankDropdown.SET_BANK_DROPDOWN_LIST:
      return {
        ...state,
        bankDropdown: {
          ...state.bankDropdown,
          data: action.payload,
        },
      };

    case DepartmentDropdown.SET_DEPARTMENT_DROPDOWN_LOADING:
      return {
        ...state,
        departmentDropdown: {
          ...state.departmentDropdown,
          isLoading: action.payload,
        },
      };

    case DepartmentDropdown.SET_DEPARTMENT_DROPDOWN_LIST:
      return {
        ...state,
        departmentDropdown: {
          ...state.departmentDropdown,
          data: action.payload,
        },
      };

    case SectionDropdown.SET_SECTION_DROPDOWN_LOADING:
      return {
        ...state,
        sectionDropdown: {
          ...state.sectionDropdown,
          isLoading: action.payload,
        },
      };

    case SectionDropdown.SET_SECTION_DROPDOWN_LIST:
      return {
        ...state,
        sectionDropdown: {
          ...state.sectionDropdown,
          data: action.payload,
        },
      };

    case SectionDropdown.SET_SECTION_DROPDOWN_ID:
      return {
        ...state,
        sectionDropdown: {
          ...state.sectionDropdown,
          id: action.payload
        }
      }

    case VehicleDropdown.SET_VEHICLE_DROPDOWN_LOADING:
      return {
        ...state,
        vehicleDropdown: {
          ...state.vehicleDropdown,
          isLoading: action.payload,
        },
      };

    case VehicleDropdown.SET_VEHICLE_DROPDOWN_LIST:
      return {
        ...state,
        vehicleDropdown: {
          ...state.vehicleDropdown,
          data: action.payload,
        },
      };

    case PermissionActions.SET_PERMISSION_DROPDOWN_LIST:
      return {
        ...state,
        permissionDropdown: {
          ...state.permissionDropdown,
          data: action.payload,
        },
      };

    case CompanyDropdown.SET_COMPANY_DROPDOWN_LOADING:
      return {
        ...state,
        companyDropdown: {
          ...state.companyDropdown,
          isLoading: action.payload,
        },
      };

    case CompanyDropdown.SET_COMPANY_DROPDOWN_LIST:
      return {
        ...state,
        companyDropdown: {
          ...state.companyDropdown,
          data: action.payload,
        },
      };

    case PackageActions.SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LIST:
      return {
        ...state,
        packageTypeNameAsValueDropdown: {
          ...state.packageTypeNameAsValueDropdown,
          data: action.payload,
        },
      };

    case PackageActions.SET_PACKAGE_TYPE_NAME_AS_VALUE_DROPDOWN_LOADING:
      return {
        ...state,
        packageTypeNameAsValueDropdown: {
          ...state.packageTypeNameAsValueDropdown,
          isLoading: action.payload,
        },
      };

    case StateDropdown.SET_STATE_DROPDOWN_LOADING:
      return {
        ...state,
        stateDropdown: {
          ...state.stateDropdown,
          isLoading: action.payload,
        },
      };

   case StateDropdown.SET_STATE_DROPDOWN_LIST:
  return {
    ...state,
    stateDropdown: {
      ...state.stateDropdown,
      data: action.payload,
    },
  };

case AreaCodeDropdown.SET_AREA_CODE_DROPDOWN_LOADING:
  return {
    ...state,
    areaCodeDropdown: {
      ...state.areaCodeDropdown,
      isLoading: action.payload,
    },
  };

case AreaCodeDropdown.SET_AREA_CODE_DROPDOWN_LIST:
  return {
    ...state,
    areaCodeDropdown: {
      ...state.areaCodeDropdown,
      data: action.payload,
    },
  };

    default:
      return state;
  }
}
